module.exports = __webpack_public_path__ + "media/application/images/pawnbroker_slider_watch-cb355f180e78b1243773df48eab9b7e1.png";